import { render, staticRenderFns } from "./LinkEl.vue?vue&type=template&id=187d68dc&scoped=true&"
import script from "./LinkEl.vue?vue&type=script&lang=ts&"
export * from "./LinkEl.vue?vue&type=script&lang=ts&"
import style0 from "./LinkEl.vue?vue&type=style&index=0&id=187d68dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187d68dc",
  null
  
)

export default component.exports